/* eslint-disable react/jsx-props-no-spreading */
import styled, { css } from "styled-components";
import ApnaTimeLogo from "../../assets/svgs/ApnaTimeLogo";

const ApnaLogo = (props) => (
	<LogoContainer {...props}>
		<ApnaTimeLogo width={56} height={56} {...props} />
	</LogoContainer>
);

// Styles
const LogoContainer = styled.div`
	& svg {
		width: 52px;
		height: 52px;
		border-radius: 10px;
		box-shadow: rgba(0, 0, 0, 0.17) 0px 8px 20px 0px;
	}
	${(props) =>
		props.height &&
		props.width &&
		css`
			& svg {
				width: ${props.width}px;
				height: ${props.height}px;
			}
		`}
`;

export default ApnaLogo;
